
// Sample data for top water consumers
export const topConsumers = [
  {
    name: "Greenview Golf Course",
    location: "7800 Fairway Drive",
    consumption: 9850,
    change: 5.2
  },
  {
    name: "Central Hospital",
    location: "237 Healthcare Drive",
    consumption: 7630,
    change: -2.1
  },
  {
    name: "Lakeside Resort",
    location: "420 Shoreline Blvd",
    consumption: 6940,
    change: 3.5
  },
  {
    name: "Downtown Water Park",
    location: "150 Splash Avenue",
    consumption: 5890,
    change: -1.3
  },
  {
    name: "University Campus",
    location: "1000 Education Way",
    consumption: 5340,
    change: 0.7
  }
];

// Sample data for defaulter consumers
export const defaulterConsumers = [
  {
    name: "Southside Golf & Country Club",
    accountId: "WAT-39284",
    location: "1200 Fairway Drive",
    outstandingAmount: 35420,
    daysOverdue: 58,
    status: "Critical"
  },
  {
    name: "Lakefront Water Park",
    accountId: "WAT-67823",
    location: "450 Splash Avenue",
    outstandingAmount: 22940,
    daysOverdue: 41,
    status: "High"
  },
  {
    name: "University Gardens Campus",
    accountId: "WAT-28473",
    location: "950 Academic Boulevard",
    outstandingAmount: 14830,
    daysOverdue: 30,
    status: "Medium"
  },
  {
    name: "Harbor View Apartments",
    accountId: "WAT-51392",
    location: "725 Waterfront Drive",
    outstandingAmount: 9720,
    daysOverdue: 22,
    status: "Medium"
  },
  {
    name: "Regional Medical Center",
    accountId: "WAT-84591",
    location: "315 Health Avenue",
    outstandingAmount: 7640,
    daysOverdue: 16,
    status: "Low"
  }
];

// Sample data for all water consumers
export const allWaterConsumers = [
  {
    name: "Greenview Golf Course",
    accountId: "WAT-39284",
    type: "Commercial",
    location: "7800 Fairway Drive",
    usage: 9850,
    status: "Active"
  },
  {
    name: "Central Hospital",
    accountId: "WAT-67823",
    type: "Institutional",
    location: "237 Healthcare Drive",
    usage: 7630,
    status: "Active"
  },
  {
    name: "Lakeside Resort",
    accountId: "WAT-28473",
    type: "Commercial",
    location: "420 Shoreline Blvd",
    usage: 6940,
    status: "Active"
  },
  {
    name: "Downtown Water Park",
    accountId: "WAT-51392",
    type: "Commercial",
    location: "150 Splash Avenue",
    usage: 5890,
    status: "Active"
  },
  {
    name: "University Campus",
    accountId: "WAT-84591",
    type: "Institutional",
    location: "1000 Education Way",
    usage: 5340,
    status: "Active"
  },
  {
    name: "Southside Golf & Country Club",
    accountId: "WAT-39284",
    type: "Commercial",
    location: "1200 Fairway Drive",
    usage: 4935,
    status: "Inactive"
  },
  {
    name: "Harbor View Apartments",
    accountId: "WAT-51392",
    type: "Residential",
    location: "725 Waterfront Drive",
    usage: 3890,
    status: "Active"
  },
  {
    name: "City Hall",
    accountId: "WAT-42973",
    type: "Municipal",
    location: "100 Civic Center",
    usage: 3250,
    status: "Active"
  },
  {
    name: "Marina Bay Complex",
    accountId: "WAT-63015",
    type: "Mixed Use",
    location: "450 Harbor Drive",
    usage: 3150,
    status: "Active"
  },
  {
    name: "Central Public Pool",
    accountId: "WAT-17584",
    type: "Municipal",
    location: "325 Recreation Way",
    usage: 2970,
    status: "Active"
  },
  {
    name: "Mountain View Apartments",
    accountId: "WAT-93726",
    type: "Residential",
    location: "840 Summit Avenue",
    usage: 2740,
    status: "Active"
  },
  {
    name: "Downtown Shopping Mall",
    accountId: "WAT-28461",
    type: "Commercial",
    location: "250 Retail Boulevard",
    usage: 2580,
    status: "Active"
  }
];
